import React from 'react'
import { wrapComponent } from "react-snackbar-alert";
function NotFound() {
  return (
      <div>
        <img src="https://www.searchenginejournal.com/wp-content/uploads/2020/08/404-pages-sej-5f3ee7ff4966b-1520x800.webp" alt="not found please contact admin"/>
    </div>
  )
}

export default wrapComponent(NotFound);